export default __webpack_public_path__ + "static/media/hat.4329e7e0.svg";